import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  "aria-modal": "true",
  ref: "new-session-dialog-content-ref",
  class: "new-session-dialog-content"
}
const _hoisted_2 = { class: "close-wrapper" }
const _hoisted_3 = ["src"]
const _hoisted_4 = { class: "big-buttons-column" }
const _hoisted_5 = { class: "big-button-content" }
const _hoisted_6 = {
  role: "presentation",
  class: "big-button-content-icon"
}
const _hoisted_7 = ["src"]
const _hoisted_8 = { class: "big-button-content big-button-disabled" }
const _hoisted_9 = {
  role: "presentation",
  class: "big-button-content-icon"
}
const _hoisted_10 = ["src"]
const _hoisted_11 = {
  key: 0,
  class: "big-button-wrapper-tag"
}
const _hoisted_12 = { class: "big-buttons-column" }
const _hoisted_13 = { class: "big-button-content" }
const _hoisted_14 = {
  role: "presentation",
  class: "big-button-content-icon"
}
const _hoisted_15 = ["src"]
const _hoisted_16 = ["disabled"]
const _hoisted_17 = {
  role: "presentation",
  class: "big-button-content-icon"
}
const _hoisted_18 = ["src"]
const _hoisted_19 = { class: "big-button-content-content" }
const _hoisted_20 = { class: "big-button-content-content-title" }
const _hoisted_21 = {
  key: 0,
  class: "big-button-wrapper-tag"
}

import { useRouter } from "vue-router";
import { computed } from "vue";
import { useStore } from "vuex";


export default /*@__PURE__*/_defineComponent({
  __name: 'NewSessionModal',
  props: {
  visible: {
    type: Boolean,
    required: true,
  },
  setVisible: {
    type: Function,
    required: true,
  },
},
  setup(__props) {


const CloseGreyIcon = require("../assets/images/Close-grey.svg") as string;
const LiveCaptionsIcon2 =
  require("../assets/images/LiveCaptionsIcon2.svg") as string;
const MicIcon = require("../assets/images/MicIcon.svg") as string;
const ScreenRecordIcon =
  require("../assets/images/ScreenRecordIcon.svg") as string;
const UploadIcon = require("../assets/images/Upload-white.svg") as string;

const router = useRouter();
const store = useStore();

const props = __props;

const isProUser = computed(() => {
  if ("subscription" in store.state.user.currentUser.self) {
    if (store.state.user.currentUser.self.subscription) {
      return store.state.user.currentUser.self.subscription.type === "pro";
    } else {
      return false;
    }
  } else {
    return false;
  }
});

function close() {
  props.setVisible(false);
}

function goToSessionSetup() {
  router.push({
    name: "SessionSetup",
  });
}

function handleKeyDown(event: KeyboardEvent, action: string) {
  if (event.key === "Enter") {
    event.preventDefault();
    (event.target as HTMLElement).blur();
    if (action === "audio-record") {
      router.push({ name: "Recorder", params: { recorderType: "audioRecorder" } });
    }
    
    if (action === "screen-record") {
      router.push({ name: "ScreenRecorder" });
    }

    if (action === "upload-files") {
      router.push({ name: "Upload" });
    }

    if (action === "live-captions") {
      goToSessionSetup();
    }
  }
}

return (_ctx: any,_cache: any) => {
  const _component_Tab = _resolveComponent("Tab")!
  const _component_TabList = _resolveComponent("TabList")!
  const _component_Tag = _resolveComponent("Tag")!
  const _component_TabPanel = _resolveComponent("TabPanel")!
  const _component_TabPanels = _resolveComponent("TabPanels")!
  const _component_Tabs = _resolveComponent("Tabs")!
  const _component_Dialog = _resolveComponent("Dialog")!
  const _directive_focustrap = _resolveDirective("focustrap")!

  return (_openBlock(), _createBlock(_component_Dialog, {
    visible: props.visible,
    class: "new-session-dialog",
    header: "false",
    closable: false,
    "aria-label": "New Session Menu",
    "close-on-escape": true
  }, {
    default: _withCtx(() => [
      _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("button", {
            class: "close",
            onclick: close
          }, [
            _createElementVNode("img", {
              src: _unref(CloseGreyIcon),
              alt: "Close menu"
            }, null, 8, _hoisted_3)
          ])
        ]),
        _cache[20] || (_cache[20] = _createElementVNode("h2", { class: "new-session-dialog-content-title" }, "New Session", -1)),
        _cache[21] || (_cache[21] = _createElementVNode("div", { class: "new-session-dialog-content-subtitle" }, " Select a session type to get started ", -1)),
        _createVNode(_component_Tabs, {
          class: "new-session-tabs",
          value: "0"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_TabList, null, {
              default: _withCtx(() => [
                _createVNode(_component_Tab, {
                  autofocus: "",
                  value: "0",
                  class: "new-session-tabs-item",
                  size: "small"
                }, {
                  default: _withCtx(() => _cache[7] || (_cache[7] = [
                    _createTextVNode(" With Recording ")
                  ])),
                  _: 1,
                  __: [7]
                }),
                _createVNode(_component_Tab, {
                  value: "1",
                  class: "new-session-tabs-item"
                }, {
                  default: _withCtx(() => _cache[8] || (_cache[8] = [
                    _createTextVNode(" Without Recording ")
                  ])),
                  _: 1,
                  __: [8]
                })
              ]),
              _: 1
            }),
            _createVNode(_component_TabPanels, null, {
              default: _withCtx(() => [
                _createVNode(_component_TabPanel, { value: "0" }, {
                  default: _withCtx(() => [
                    _cache[13] || (_cache[13] = _createElementVNode("div", { class: "new-session-dialog-content-panel" }, " Before starting a recording: Please kindly seek consent for everyone's comfort. ", -1)),
                    _createElementVNode("div", _hoisted_4, [
                      _createElementVNode("button", {
                        class: "big-button",
                        "aria-label": 'Record new audio',
                        "aria-describedby": 'record-audio-desc',
                        onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(router).push({ name: 'Recorder', params: { recorderType: 'audioRecorder' } }))),
                        onKeydown: _cache[1] || (_cache[1] = ($event: any) => (handleKeyDown($event, 'audio-record')))
                      }, [
                        _createElementVNode("div", _hoisted_5, [
                          _createElementVNode("div", _hoisted_6, [
                            _createElementVNode("img", {
                              "aria-label": "Microphone icon",
                              src: _unref(MicIcon),
                              alt: "AudioRecordIcon"
                            }, null, 8, _hoisted_7)
                          ]),
                          _cache[9] || (_cache[9] = _createElementVNode("div", { class: "big-button-content-content" }, [
                            _createElementVNode("div", { class: "big-button-content-content-title" }, " Audio Recording "),
                            _createElementVNode("div", { class: "big-button-content-content-text" }, " Record a lecture effortlessly and add personal notes. ")
                          ], -1)),
                          _cache[10] || (_cache[10] = _createElementVNode("div", {
                            id: "record-audio-desc",
                            class: "sr-only"
                          }, "Audio Recording, record a lecture effortlessly and add personal notes.", -1))
                        ])
                      ], 32),
                      _createElementVNode("button", {
                        class: "big-button",
                        "aria-label": 'Screen Recording',
                        "aria-describedby": 'record-screen-desc',
                        onClick: _cache[2] || (_cache[2] = ($event: any) => (_unref(router).push({ name: 'ScreenRecorder' }))),
                        disabled: "",
                        onKeydown: _cache[3] || (_cache[3] = ($event: any) => (handleKeyDown($event, 'screen-record')))
                      }, [
                        _createElementVNode("div", _hoisted_8, [
                          _createElementVNode("div", _hoisted_9, [
                            _createElementVNode("img", {
                              "aria-hidden": "true",
                              src: _unref(ScreenRecordIcon),
                              alt: "ScreenRecordIcon"
                            }, null, 8, _hoisted_10)
                          ]),
                          _cache[11] || (_cache[11] = _createElementVNode("div", { class: "big-button-content-content" }, [
                            _createElementVNode("div", { class: "big-button-content-content-title" }, " Screen Recording "),
                            _createElementVNode("div", { class: "big-button-content-content-text" }, " Record your screen and add notes. ")
                          ], -1)),
                          _cache[12] || (_cache[12] = _createElementVNode("div", {
                            id: "record-screen-desc",
                            class: "sr-only"
                          }, "Screen Recording, record your screen and add personal notes.", -1))
                        ]),
                        (!isProUser.value)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                              _createVNode(_component_Tag, {
                                value: "COMING SOON",
                                class: "big-button-tag"
                              })
                            ]))
                          : _createCommentVNode("", true)
                      ], 32)
                    ])
                  ]),
                  _: 1,
                  __: [13]
                }),
                _createVNode(_component_TabPanel, { value: "1" }, {
                  default: _withCtx(() => [
                    _cache[19] || (_cache[19] = _createElementVNode("div", { class: "new-session-dialog-content-panel" }, " Share thoughtfully: Make sure to get consent and keep confidentiality in mind. ", -1)),
                    _createElementVNode("div", _hoisted_12, [
                      _createElementVNode("button", {
                        class: "big-button",
                        onClick: _cache[4] || (_cache[4] = ($event: any) => (_unref(router).push({ name: 'Upload' }))),
                        onKeydown: _cache[5] || (_cache[5] = ($event: any) => (handleKeyDown($event, 'upload-files'))),
                        "aria-label": "Upload files",
                        "aria-describedby": "upload-files-desc"
                      }, [
                        _createElementVNode("div", _hoisted_13, [
                          _createElementVNode("div", _hoisted_14, [
                            _createElementVNode("img", {
                              role: "presentation",
                              src: _unref(UploadIcon),
                              alt: "UploadIcon"
                            }, null, 8, _hoisted_15)
                          ]),
                          _cache[14] || (_cache[14] = _createElementVNode("div", { class: "big-button-content-content" }, [
                            _createElementVNode("div", { class: "big-button-content-content-title" }, " Upload Files "),
                            _createElementVNode("div", { class: "big-button-content-content-text" }, " Upload audio, video files or PDFs for editable transcription. ")
                          ], -1)),
                          _cache[15] || (_cache[15] = _createElementVNode("div", {
                            id: "record-audio-desc",
                            class: "sr-only"
                          }, "Upload files, upload audio, video files or PDFs for editable transcription. ", -1))
                        ])
                      ], 32),
                      _createElementVNode("button", {
                        class: "big-button",
                        onClick: goToSessionSetup,
                        onKeydown: _cache[6] || (_cache[6] = ($event: any) => (handleKeyDown($event, 'new-folder'))),
                        disabled: !isProUser.value,
                        "aria-label": "Live Captions",
                        "aria-describedby": "live-captions-desc"
                      }, [
                        _createElementVNode("div", {
                          class: _normalizeClass(["big-button-content", { 'big-button-disabled': !isProUser.value }])
                        }, [
                          _createElementVNode("div", _hoisted_17, [
                            _createElementVNode("img", {
                              role: "presentation",
                              src: _unref(LiveCaptionsIcon2),
                              alt: "LiveCaptionsIcon2"
                            }, null, 8, _hoisted_18)
                          ]),
                          _createElementVNode("div", _hoisted_19, [
                            _createElementVNode("div", _hoisted_20, [
                              _cache[16] || (_cache[16] = _createTextVNode(" Live Captions ")),
                              _createVNode(_component_Tag, {
                                class: "big-button-content-content-title-tag tag-pro",
                                value: "PRO"
                              })
                            ]),
                            _cache[17] || (_cache[17] = _createElementVNode("div", { class: "big-button-content-content-text" }, " Enable real-time captions for live audio, without recording. ", -1))
                          ]),
                          _cache[18] || (_cache[18] = _createElementVNode("div", {
                            id: "live-captions-desc",
                            class: "sr-only"
                          }, "Only available for pro users, Live Captions, enable real-time captions for live audio, without recording.", -1))
                        ], 2),
                        (!isProUser.value)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                              _createVNode(_component_Tag, {
                                value: "COMING SOON",
                                class: "big-button-tag"
                              })
                            ]))
                          : _createCommentVNode("", true)
                      ], 40, _hoisted_16)
                    ])
                  ]),
                  _: 1,
                  __: [19]
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ])), [
        [_directive_focustrap]
      ])
    ]),
    _: 1
  }, 8, ["visible"]))
}
}

})